import { FormModeV2 } from "../FormControlsV2";
import { DisabledFieldsV2 } from "./types";

export function isDisabled<T extends string>(field: T, mode: FormModeV2, disabledFields: DisabledFieldsV2<T> = []) {
  return mode === "readonly" || disabledFields.includes(field);
}

export function stringifyCoords(coords: any[]) {
  if (!coords || coords.length === 0) return "";
  try {
    return JSON.stringify(coords);
  } catch {
    return "";
  }
}

export function parseCoords(value: string) {
  if (!value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function createAutomaticFarmInitials(name: string) {
  const words = name.trim().toUpperCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2);
  return `${words[0].charAt(0)}${words[1].charAt(0)}`;
}

export function createAutomaticAreaInitials(name: string) {
  const words = name.trim().toUpperCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2);
  return `${words[0].charAt(0)}${words[1].charAt(0)}`;
}
